// extracted by mini-css-extract-plugin
export default {"frameGradient":"frame_card_frameGradient__P8jjl","card":"frame_card_card__pQhMy"};